export const subscribeStatusEnum = {
    READY_TO_ACTIVE:"رزرو شده",
    ACTIVE:"فعال",
    PROCESSING:"در حال ربررسی",
    PAYMENT_WAIT:"در انتظار پرداخت",
    EXPIRE:"منقضی",
    REFUNDED:"بازپرداخت شده",
    COMPLETE:"تکمیل",
    CANCEL:"لغو",
}
